export const COLUMN_WIDTH = {
  AMOUNT: 200,
  DATE: 190,
  ACTIONS: 150,
} as const
